import { forwardRef } from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

type InternalProps = {
	decimalScale?: number;
	onChange: (event: { target: { value: string } }) => void;
};

export const NumericInput = forwardRef<NumericFormatProps, InternalProps>((props, ref) => {
	const { decimalScale = 2, onChange, ...rest } = props;

	return (
		<NumericFormat
			{...rest}
			decimalScale={decimalScale}
			getInputRef={ref}
			onValueChange={(values) =>
				onChange({
					target: {
						value: values.value,
					},
				})
			}
		/>
	);
});
